import { render } from "./HomeItsTestimonialComp.vue?vue&type=template&id=0c83122b&scoped=true"
import script from "./HomeItsTestimonialComp.vue?vue&type=script&lang=js"
export * from "./HomeItsTestimonialComp.vue?vue&type=script&lang=js"

import "./HomeItsTestimonialComp.vue?vue&type=style&index=0&id=0c83122b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c83122b"]])

export default __exports__